import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-9 pt-5 d-flex justify-content-center"
}
const _hoisted_2 = { class: "seq-encash-banner" }
const _hoisted_3 = { class: "seq-encash-banner__icon svg-icon svg-icon-2" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "seq-encash-banner__text" }, [
  /*#__PURE__*/_createVNode("span", { class: "seq-encash-banner__title" }, "Reload your EC Wallet"),
  /*#__PURE__*/_createVNode("span", { class: "seq-encash-banner__desc" }, "Tap an amount to add or subtract, then confirm the total before proceeding.")
], -1)
const _hoisted_5 = { class: "card-body py-3" }
const _hoisted_6 = {
  key: 0,
  class: "col-xxl-12"
}
const _hoisted_7 = { class: "mw-500px mx-auto" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label" }, "Quick amounts", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label" }, "Adjust", -1)
const _hoisted_10 = { class: "seq-pill-toggle mb-5" }
const _hoisted_11 = { class: "seq-breakdown" }
const _hoisted_12 = { class: "seq-breakdown__row seq-breakdown__row--total" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "seq-breakdown__label" }, "TOTAL", -1)
const _hoisted_14 = { class: "seq-breakdown__value" }
const _hoisted_15 = {
  key: 0,
  class: "seq-breakdown__row"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "seq-breakdown__label" }, "Philippine Peso", -1)
const _hoisted_17 = { class: "seq-breakdown__value" }
const _hoisted_18 = {
  key: 1,
  class: "seq-breakdown__row"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "seq-breakdown__label" }, "Philippine Peso", -1)
const _hoisted_20 = { class: "seq-breakdown__value" }
const _hoisted_21 = { class: "row mb-5" }
const _hoisted_22 = { class: "col-md-12 fv-row py-1 text-center" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Proceed")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Processing...")
const _hoisted_26 = {
  key: 1,
  class: "col-xxl-12"
}
const _hoisted_27 = { class: "mw-500px mx-auto text-center py-5" }
const _hoisted_28 = /*#__PURE__*/_createVNode("h3", { class: "seq-otp-title fs-2" }, "Verify your EC Wallet reload", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("p", { class: "seq-otp-subtitle" }, "Please enter the OTP sent to your mobile phone.", -1)
const _hoisted_30 = { class: "my-8" }
const _hoisted_31 = { class: "d-grid col-10 col-sm-8 mx-auto" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Verify")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Processing...")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_OtpInput = _resolveComponent("OtpInput")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 8,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card seq-card"]
    }, [
      (_ctx.hasPendingECWalletOTP == false)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", _hoisted_3, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Credit-card.svg" })
              ]),
              _hoisted_4
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_5, [
        (_ctx.hasPendingECWalletOTP == false)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode("div", {
                  class: ["seq-amount-chips mb-4", _ctx.ccode != '27' ? 'seq-amount-chips--4' : 'seq-amount-chips--3']
                }, [
                  (_ctx.ccode != '27')
                    ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.defaultAmounts, (amount) => {
                        return (_openBlock(), _createBlock("button", {
                          key: amount,
                          type: "button",
                          class: "seq-amount-chip",
                          onClick: ($event: any) => (_ctx.computeTotalAmount(amount))
                        }, _toDisplayString(_ctx.numberWithCommas(Number(amount).toFixed(2))), 9, ["onClick"]))
                      }), 128))
                    : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.tanzaniaAmounts, (amount) => {
                        return (_openBlock(), _createBlock("button", {
                          key: amount,
                          type: "button",
                          class: "seq-amount-chip",
                          onClick: ($event: any) => (_ctx.computeTotalAmount(amount))
                        }, _toDisplayString(_ctx.numberWithCommas(Number(amount).toFixed(2))), 9, ["onClick"]))
                      }), 128))
                ], 2),
                _hoisted_9,
                _createVNode("div", _hoisted_10, [
                  _createVNode("button", {
                    type: "button",
                    class: ["seq-pill-toggle__btn", { active: _ctx.optionsRadios == 1 }],
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.optionsRadios = 1))
                  }, " + Add ", 2),
                  _createVNode("button", {
                    type: "button",
                    class: ["seq-pill-toggle__btn", { active: _ctx.optionsRadios == 0 }],
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.optionsRadios = 0))
                  }, " − Subtract ", 2)
                ]),
                _createVNode("div", _hoisted_11, [
                  _createVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode("span", _hoisted_14, _toDisplayString(_ctx.numberWithCommas(_ctx.totalAmount)) + " " + _toDisplayString(_ctx.currency), 1)
                  ]),
                  (_ctx.ccode == '29')
                    ? (_openBlock(), _createBlock("div", _hoisted_15, [
                        _hoisted_16,
                        _createVNode("span", _hoisted_17, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.totalAmount2 / 0.35).toFixed(2))), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.ccode == '27')
                    ? (_openBlock(), _createBlock("div", _hoisted_18, [
                        _hoisted_19,
                        _createVNode("span", _hoisted_20, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.totalAmount2 / 50).toFixed(2))), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-seq-blue min-w-100px",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancel_ecwalletReload()))
                    }, " Reset "),
                    _hoisted_23,
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-seq-green min-w-100px",
                      disabled: _ctx.isProcessingReload,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.process_ecwalletReload()))
                    }, [
                      (_ctx.isProcessingReload == false)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _hoisted_24
                          ], 64))
                        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                            _hoisted_25
                          ], 64))
                    ], 8, ["disabled"])
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _hoisted_28,
                _hoisted_29,
                _createVNode("div", _hoisted_30, [
                  _createVNode(_component_OtpInput, {
                    modelValue: _ctx.model_ecwallet_otp,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.model_ecwallet_otp = $event)),
                    length: 6,
                    disabled: _ctx.isProcessingOTP
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _createVNode("div", _hoisted_31, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-seq-blue",
                    disabled: _ctx.isProcessingOTP,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.process_ecwalletOTP()))
                  }, [
                    (_ctx.isProcessingOTP == false)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _hoisted_32
                        ], 64))
                      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _hoisted_33
                        ], 64))
                  ], 8, ["disabled"])
                ])
              ])
            ]))
      ])
    ], 2), [
      [_vShow, !_ctx.loading && _ctx.isAllowedECWallet]
    ])
  ], 64))
}